<template>
  <FormulateInput @click="dadosForm" :type="type" :label="label" />
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ButtonComponent",
  props: {
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
      required: true,
      default: "submit",
    },
  },
  computed: {
    ...mapGetters("formularios", ["formValues"]),
  },
  methods: {
    dadosForm() {
      this.$emit('salvarFormularioDinamico');
    },
  },
};
</script>